/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Video_Complete_ToastInputs */



/**
* | output |
* | --- |
* | "Video with Audio Description exported successfully" |
*
* @param {Audio_Description_Export_Video_Complete_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_video_complete_toast = /** @type {((inputs?: Audio_Description_Export_Video_Complete_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Video_Complete_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vidéo avec description audio exportée avec succès")
	if (locale === "de") return /** @type {LocalizedString} */ ("Video mit Audiobeschreibung erfolgreich exportiert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Video con descrizione audio esportato correttamente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Видео с аудиоописанием успешно экспортировано.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vídeo con descripción de audio exportado correctamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("已成功导出带有音频描述的视频")
	if (locale === "ja") return /** @type {LocalizedString} */ ("音声説明付きのビデオが正常にエクスポートされました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो विवरण सहित वीडियो सफलतापूर्वक निर्यात हो गया है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Vídeo com audiodescrição exportado com sucesso.")
	return /** @type {LocalizedString} */ ("Video with Audio Description exported successfully")
});